import { Card } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

interface TooltipWrapperProps extends ComponentProps<typeof Card> {}

export const TooltipWrapper = memo<TooltipWrapperProps>((props) => {
	const { children, className, size = "sm", variant = "surface", ...rest } = props

	return (
		<Card
			className={cx("bg-(--color-background) dark:bg-(--base-2) min-w-48 max-w-xs", className)}
			size={size}
			variant={variant}
			{...rest}
		>
			{children}
		</Card>
	)
})
TooltipWrapper.displayName = "TooltipWrapper"
